import { render } from "./CompleteRegistration.vue?vue&type=template&id=30656d3e"
import script from "./CompleteRegistration.vue?vue&type=script&lang=js"
export * from "./CompleteRegistration.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src511626146/src/application/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__